// export const baseUrl = "http://localhost:4000";
export const baseUrl = process.env.REACT_APP_BASE_URL;

// export const analyticsUrl = "http://localhost:8000";
export const analyticsUrl = process.env.REACT_APP_PYTHON_API;

export const analyticsUrl_2 = process.env.REACT_APP_ANALYTICS_API_2;
